import { useEffect, useState } from 'react';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { Button } from '@skupreme/shared/ui';

import DialogBox from '@components/GlobalSearch/DialogBox';

/** The trigger, the ⌘K shortcut and the dialog they share. */
export function GlobalSearch() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.metaKey && e.key === 'k') {
        e.preventDefault();
        e.stopPropagation();
        setOpen(value => !value);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      <Button
        variant="pill"
        shape="circle"
        size="md"
        aria-label="Search"
        onPress={() => setOpen(true)}
      >
        <MagnifyingGlassIcon size={14} />
      </Button>
      <DialogBox open={open} setOpen={setOpen} />
    </>
  );
}
